export const SESSION_KEY = '_cut';

export function getToken(): string | null {
    return localStorage.getItem(SESSION_KEY);
}

export function setToken(token: string): void {
    localStorage.setItem(SESSION_KEY, token);
    
    // Set cookie for browser-based flows (like OAuth)
    const domain = getDomain();
    const domainString = domain ? `; domain=${domain}` : '';
    // SameSite=Lax is sufficient and compatible with most OAuth flows
    document.cookie = `crate_session=${token}; path=/; SameSite=Lax; Secure${domainString}`;

    window.dispatchEvent(new CustomEvent('auth-state-changed', {
        detail: { isAuthenticated: true }
    }));
}

export function clearSession(): void {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem('crate_org_id');
    localStorage.removeItem('crate_onboarding_org_id');
    localStorage.removeItem('crate_onboarding_plan');
    localStorage.removeItem('crate_onboarding_modules');

    const domain = getDomain();
    const domainString = domain ? `; domain=${domain}` : '';
    document.cookie = `crate_session=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${domainString}`;

    window.dispatchEvent(new CustomEvent('auth-state-changed', {
        detail: { isAuthenticated: false }
    }));
}

export function logoutAndRedirect(): void {
    clearSession();
    window.history.pushState({}, '', '/'); window.dispatchEvent(new CustomEvent('auth-state-changed'));
}

function getDomain(): string {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        return '';
    }
    const parts = hostname.split('.');
    if (parts.length >= 2) {
        return '.' + parts.slice(-2).join('.');
    }
    return '';
}
